module.exports = __webpack_public_path__ + "img/match--type1_img4--sp.7d29782e.png";